import React, { useEffect, useState, useRef } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import { MoreVert as MoreIcon, LocationOn as MapMarkerIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { FETCH_PROJECTS_PRODUCTS } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { BIGrey, BIRed } from "../../assets/helpers";
import defaultProjectImage from "../../assets/images/placeholder_img.jpg";
import SearchField from "../common/SearchField";
import { useDispatch } from "react-redux";
import {
  setSelectedProjectdata,
  setShowmapmodal,
  setShowReport
} from "../../redux/actions/actions";
import Removeduplicates from "../common/Removeduplicate";
import Emptydata from "../common/Emptydata";
import InfiniteScroll from "react-infinite-scroll-component";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";

function ProductProjectSection({ id, scrollId, color="" }) {
  const { loginData, selectedProject, multiLanguageData, reportSuccess } = useSelector(
    (state) => state?.main
  );
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const LanguageData = multiLanguageData?.Products || {};
  const {
    TEXT_PRODUCT_PROJECTS_DESC = English.Products.TEXT_PRODUCT_PROJECTS_DESC,
    TEXT_SEARCH_PRODUCT_PROJECTS = English.Products.TEXT_SEARCH_PRODUCT_PROJECTS,
    BUTTON_ADD_PROJECT = English.Products.BUTTON_ADD_PROJECT,
    BUTTON_REPORT = English.Products.BUTTON_REPORT,
    TEXT_NO_RESULTS_FOUND = English.Products.TEXT_NO_RESULTS_FOUND,
    TEXT_NO_PROJECT_FOUND = English.Products.TEXT_NO_PROJECT_FOUND
  } = LanguageData || {};
  const debounceTimeout = useRef(null);
  const [projectData, setProjectData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [projectDetails, setProjectDetails] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    if (reportSuccess !== true) getInitialData();
  }, [reportSuccess]);

  useEffect(() => {
    if (selectedProject?.from === "product-detail") {
      getInitialData();
    }
  }, [selectedProject]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getProjectData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getProjectData = async (searchTerm, pageNumber, fristTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        SearchList: [{ productId: id }],
        userId: currentUserId,
        IncludeRecordNr: true,
        SortList: [{}],
        FetchAllowedRecordsOnly: true,
        TypeOfObjectReturned: ""
      };
      // API call to fetch project data
      const getResponse = await Postrequestcall(
        FETCH_PROJECTS_PRODUCTS,
        obj,
        loginData?.accessToken
      );
      if (getResponse.status === 200) {
        let resData = getResponse?.data?.data ?? [];
        let updatedData = Removeduplicates(resData, "projectId");
        let sortedData =
          updatedData?.sort((a, b) => a?.projectName?.localeCompare(b?.projectName)) ?? [];
        if (pageNumber > 1) {
          setTimeout(() => {
            setProjectData((prevProducts) => [...prevProducts, ...sortedData]);
          }, 500);
        } else {
          setProjectData(sortedData);
          if (fristTimeApiCall) {
            setHasData(sortedData?.length > 0);
          }
        }
      }
    } catch (error) {
      console.log("getProjectData-> Error WHile Getting Project Product: ", error);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      name: Pages?.productProject?.name,
      AppScreenId: Pages?.productProject?.id,
      recordId: projectDetails.projectId ?? 0
    };
    dispatch(setShowReport(reportObj));
  };

  const onAddProjectClick = () => {
    let mapModal = {
      open: true,
      from: "product-detail",
      select: "project"
    };
    dispatch(setShowmapmodal(mapModal));
  };

  const onItemClick = (item) => {
    navigate(`/project/${item?.projectId}`);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const NoInformation = () => {
    return (
      <Stack  sx={{ gap: 1, height: "100%" }}>
        <Button variant="text" sx={{ alignSelf: "flex-end", color:color }} onClick={onAddProjectClick}>
          {BUTTON_ADD_PROJECT}
        </Button>
        <Box className="empty-data-card">
          <Emptydata
            icon={<MapMarkerIcon className="emptydata-icon" />}
            firstText={TEXT_NO_PROJECT_FOUND}
          />
        </Box>
      </Stack>
    );
  };

  const renderListing = () => {
    return (
      <Stack sx={{ gap: 1 }} >
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {TEXT_PRODUCT_PROJECTS_DESC}
        </Typography>
        <SearchField
          placeholder={TEXT_SEARCH_PRODUCT_PROJECTS}
          value={searchTerm}
          onChange={(value) => {
            setShowSearchLaoder(true);
            const searchValue = value;
            setSearchTerm(searchValue);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getProjectData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setShowSearchLaoder(true);
            setShowSearchLaoder(searchTerm);
            getProjectData(searchTerm, 1);
          }}
          size={"small"}
        />
        <Button variant="text" sx={{ alignSelf: "flex-end", color:color }} onClick={onAddProjectClick}>
          {BUTTON_ADD_PROJECT}
        </Button>
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : projectData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={projectData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getProjectData(searchTerm, pageNumber);
                  });
                }}
                hasMore={true}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  <Stack sx={{ gap: 1 }} >
                    {projectData.map((item) => (
                      <Card key={item?.id} className="pagelist-content">
                        <ListItem
                          key={item?.id}
                          style={{ padding: "0px" }}
                          secondaryAction={
                            <IconButton
                              onClick={(event) => {
                                setProjectDetails(item);
                                setMoreMenuAnchorEl(event.currentTarget);
                              }}>
                              <MoreIcon />
                            </IconButton>
                          }>
                          <ListItemButton
                            onClick={() => {
                              onItemClick(item);
                            }}>
                            <Avatar
                              variant="rounded"
                              style={{ margin: "5px 15px 5px 5px" }}
                              src={item?.thumbUrl || defaultProjectImage}
                            />
                            <ListItemText primary={item?.projectName} secondary={item?.address} />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    ))}
                  </Stack>
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {BUTTON_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction={"row"} style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Stack>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}
      </Card>
    </Box>
  );
}

export default ProductProjectSection;

